
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import '../styles/globals.css';
import 'moment/locale/it';
import 'moment/locale/fr';
import 'moment/locale/pt';
import 'moment/locale/de';
import 'moment/locale/es';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import 'react-awesome-lightbox/build/style.css';
import '../components/PdfViewer/pdfviewer.css';
import '../components/RichTextEditor/richtexteditor.css';
import * as Yup from 'yup';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Application from '../components/Application';
import config from '../config';
import CssBaseline from '@material-ui/core/CssBaseline';
import Head from 'next/head';
import { InjectStoreContext } from '../store';
import moment from 'moment';
import { inter } from '../styles/fonts';
import theme from '../styles/theme';
import { ThemeProvider } from '@material-ui/core/styles';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
const queryClient = new QueryClient();
const APP_TITLE = [config.APP_NAME, 'Proprietari'];
if (config.NODE_ENV === 'development') {
    APP_TITLE.push('DEV');
}
else if (config.DEMO_MODE) {
    APP_TITLE.push('DEMO');
}
// Titolo della scheda per pagina: cura da prodotto, niente titolo unico ovunque.
const NOME_APP = config.APP_NAME || 'Dimora';
const TITOLI_PAGINE = {
    '/': `${NOME_APP} — Gestionale per locazioni immobiliari`,
    '/signin': `Accedi — ${NOME_APP}`,
    '/signup': `Crea un account — ${NOME_APP}`,
    '/forgotpassword': `Recupero password — ${NOME_APP}`,
    '/firstaccess': `Prima organizzazione — ${NOME_APP}`,
    '/privacy': `Privacy — ${NOME_APP}`,
    '/termini': `Termini d'uso — ${NOME_APP}`,
    '/contatti': `Contatti — ${NOME_APP}`,
    '/404': `Pagina non trovata — ${NOME_APP}`,
    '/[organization]/dashboard': `Cruscotto — ${NOME_APP}`,
    '/[organization]/rents/[yearMonth]': `Affitti — ${NOME_APP}`,
    '/[organization]/tenants': `Inquilini — ${NOME_APP}`,
    '/[organization]/tenants/[id]': `Scheda inquilino — ${NOME_APP}`,
    '/[organization]/properties': `Immobili — ${NOME_APP}`,
    '/[organization]/properties/[id]': `Scheda immobile — ${NOME_APP}`,
    '/[organization]/accounting/[year]': `Contabilità — ${NOME_APP}`
};
function titoloPagina(pathname) {
    if (TITOLI_PAGINE[pathname]) {
        return TITOLI_PAGINE[pathname];
    }
    if (pathname.startsWith('/[organization]/settings')) {
        return `Impostazioni — ${NOME_APP}`;
    }
    if (pathname.startsWith('/resetpassword')) {
        return `Nuova password — ${NOME_APP}`;
    }
    return APP_TITLE.join(' - ');
}
Yup.addMethod(Yup.string, 'emails', function (message) {
    return this.test({
        name: 'emails',
        message: message || '${path} one of the emails is invalid or is not unique',
        test: (value) => {
            if (value == null) {
                return true;
            }
            const schema = Yup.string().email();
            const emails = value.replace(/\s/g, '').split(',');
            return (emails.every((email) => schema.isValidSync(email)) &&
                emails.length === new Set(emails).size);
        }
    });
});
function MyApp(props) {
    const { Component, pageProps } = props;
    const router = useRouter();
    moment.locale(pageProps?.__lang ?? 'it-IT');
    useEffect(() => {
        // Remove the server-side injected CSS.
        const jssStyles = document.querySelector('#jss-server-side');
        if (jssStyles) {
            jssStyles.parentElement.removeChild(jssStyles);
        }
    }, []);
    // Pagine pubbliche (landing, privacy, termini, contatti): niente store né
    // layout applicativo, così il server restituisce l'HTML già completo.
    if (Component.paginaPubblica) {
        return (<>
        <Head>
          <title>{titoloPagina(router.pathname)}</title>
          <meta name="theme-color" content={theme.palette.primary.main}/>
          <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width"/>
          <link rel="shortcut icon" href={`${config.BASE_PATH}/favicon.svg`}/>
        </Head>
        <main className={`${inter.variable} ${inter.className}`}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Component {...pageProps}/>
          </ThemeProvider>
        </main>
      </>);
    }
    return (<>
      <Head>
        <title>{titoloPagina(router.pathname)}</title>
        {/* PWA primary color */}
        <meta name="theme-color" content={theme.palette.primary.main}/>
        <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width"/>
        <link rel="shortcut icon" href={`${config.BASE_PATH}/favicon.svg`}/>
      </Head>
      <main className={`${inter.variable} ${inter.className}`}>
        <ThemeProvider theme={theme}>
          {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
          <CssBaseline />
          <QueryClientProvider client={queryClient}>
            <InjectStoreContext initialData={pageProps.initialState?.store}>
              <Application {...pageProps}>
                <Component {...pageProps}/>
              </Application>
            </InjectStoreContext>
          </QueryClientProvider>
        </ThemeProvider>
      </main>
    </>);
}
const __Next_Translate__Page__19fd5e3c67d__ = MyApp;

    export default __appWithI18n(__Next_Translate__Page__19fd5e3c67d__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  